'use client'

import React from 'react'
import { MetaData } from '@/types/cms'

export const MetaDataContext = React.createContext<MetaData | undefined>(undefined)

export const MetaDataProvider: React.FC<{ metadata: MetaData | undefined; children: React.ReactNode }> = ({
  metadata,
  children,
}) => {
  return <MetaDataContext.Provider value={metadata}>{children}</MetaDataContext.Provider>
}
